export default __webpack_public_path__ + "static/media/no.e874c44f.jpg";